import React, { useContext, useState } from "react";
import DrawerProcessamento from "./index";
import { useCallback } from "react";
import { TaskResponse } from "core/features/task/typings";

interface ProcessamentoModalValues {
  isOpenDrawer: boolean;
  onOpen: () => any;
  onClose: () => any;
  pushLocalTask: (
    task: Omit<TaskResponse, "id" | "createdAt"> & {
      id?: string;
      createdAt?: number;
    }
  ) => void;
  localTasks: TaskResponse[];
}

const ProcessamentoModal = React.createContext<ProcessamentoModalValues>({
  isOpenDrawer: false,
  onOpen: () => {},
  onClose: () => {},
  pushLocalTask: () => {},
  localTasks: [],
});

function ProcessamentoModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [refetchSignal, setRefetchSignal] = useState<number | undefined>(
    undefined
  );
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [localTasks, setLocalTasks] = useState<TaskResponse[]>([]);

  const onOpen = useCallback(() => {
    setIsOpenDrawer(true);
    setRefetchSignal(Date.now());
  }, []);

  const onClose = useCallback(() => {
    setIsOpenDrawer(false);
  }, []);

  const pushLocalTask = useCallback(
    (
      task: Omit<TaskResponse, "id" | "createdAt"> & {
        id?: string;
        createdAt?: number;
      }
    ) => {
      const now = Date.now();
      setLocalTasks((prev) => [
        ...prev,
        {
          ...task,
          id: task.id || now.toString(),
          createdAt: task.createdAt || now,
        } as TaskResponse,
      ]);
      setIsOpenDrawer(true);
    },
    []
  );

  return (
    <ProcessamentoModal.Provider
      value={{ isOpenDrawer, onOpen, onClose, pushLocalTask, localTasks }}
    >
      {isOpenDrawer ? (
        <DrawerProcessamento
          isOpen={isOpenDrawer}
          onClose={onClose}
          refetchSignal={refetchSignal}
          localTasks={localTasks}
        />
      ) : null}
      {children}
    </ProcessamentoModal.Provider>
  );
}

export function useProcessamentoModal() {
  return useContext(ProcessamentoModal);
}

export default ProcessamentoModalProvider;
